const getInteractives = state => state.player.interactives || new Map();

export default getInteractives;
